import { render, staticRenderFns } from "./editModal3.vue?vue&type=template&id=1b5ac1c4&"
import script from "./editModal3.vue?vue&type=script&lang=js&"
export * from "./editModal3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports